import { all } from 'redux-saga/effects'
import authSaga from '@iso/redux/auth/saga'

export default function* rootSaga(getState) {
  yield all([authSaga()])
}
